export default __webpack_public_path__ + "static/google_podcast-084037dd5391ea0a87763e73739678b7.svg";